<template>
  <div class="output-trend-change" ref="chartRef" style="width: 100%; height: 300px;"></div>
</template>

<script>
import * as echarts from 'echarts'
import { getOutputTrend } from "../api";
import { extractTitleAndValueArrays } from "@/basic-common/util/common";
export default {
  name: 'OutputTrendChange',
  inject: ['parentThat'],

  data () {
    return {
      chart: null
    };
  },
  mounted () {
    this.chart = echarts.init(this.$refs.chartRef);
    this.initChart();
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.handleResize);
    if (this.chart) {
      this.chart.dispose();
    }
  },
  methods: {
    initChart () {
      const { queryForm } = this.parentThat
      getOutputTrend(queryForm).then(({ data }) => {
        const { dates, teamData } = data.data
        const dataAll = extractTitleAndValueArrays(teamData, 'teamName', 'completedCounts')
        teamData.forEach((item) => {
          item.name = item.teamName
          item.data = item.completedCounts
          item.type = 'line'
          item.symbol = 'circle'
        })
        this.setOption(dataAll, teamData, dates)
      })

    },
    setOption (dataAll, teamData, dates) {
      const option = {
        title: {
          text: '产出趋势变化',
          left: '10%',
          top: '5%'
        },
        legend: {
          data: dataAll.titles,
          top: '15%'
        },
        xAxis: {
          type: 'category',
          data: dates
        },
        yAxis: {
          type: 'value',
          min: 0,
          max: 30
        },
        series: teamData,
        // series: [
        //   {
        //     name: '全公司平均',
        //     type: 'line',
        //     symbol: 'circle',
        //     data: [20, 20, 19, 21, 22, 21, 19]
        //   },
        //   {
        //     name: '煤流线管理员',
        //     type: 'line',
        //     symbol: 'circle',
        //     data: [28, 27, 29, 28, 28, 28, 29],
        //     itemStyle: {
        //       color: '#4895ef'
        //     }
        //   },
        //   {
        //     name: '维修工程师',
        //     type: 'line',
        //     symbol: 'circle',
        //     data: [25, 25, 26, 25, 25, 26, 25],
        //     itemStyle: {
        //       color: '#00b42a'
        //     }
        //   }
        // ],
        grid: {
          left: '10%',
          right: '10%',
          top: '25%',
          bottom: '10%'
        }
      };
      this.chart.setOption(option);
    },
    handleResize () {
      if (this.chart) {
        this.chart.resize();
      }
    }
  }
};
</script>